var mobileWidth = 1023;

$(document).ready(function () {
  $(".full-width-slider").royalSlider({
    // general options go gere
    slidesSpacing: 0,
    arrowsNavAutoHide: false,
    keyboardNavEnabled: true,
    transitionType: "fade",
    transitionSpeed: 800,
    imageScaleMode: "fill",
    numImagesToPreload: 5,
    controlNavigation: "none",
  });

  $(".gallery_openLink").bind("click", function () {
    var galleryOverlay = $(this).parent().find(".overlay");
    $(galleryOverlay).fadeIn(500);
    $(galleryOverlay).width("100%");
    $(galleryOverlay).height("100%");
    window.dispatchEvent(new Event("resize"));

    $(window).resize(function () {
      $(galleryOverlay).width("100%");
      $(galleryOverlay).height("100%");
    });
    $(galleryOverlay)
      .find(".close")
      .click(function () {
        $(".gallery .overlay").fadeOut(300);
      });

    document.onkeydown = function (evt) {
      if (evt.keyCode == 27) {
        $(".gallery .overlay").fadeOut(300);
      }
    };

    return false;
  });

  $(".slides").slick({
    dots: false,
    infinite: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    speed: 800,
    pauseOnHover: true,
    cssEase: "ease",
  });

  $("#nav-toggle").click(function () {
    $(".wrapper-navigation, #nav-toggle").toggleClass("active");
    $(".wrapper-navigation").scrollLeft(0);
    return false;
  });

  $(".wrapper-subnavigation").click(function (e) {
    if ($(e.target).hasClass("scroller")) {
      $("html").removeClass("noscroll");
      $(".wrapper-subnavigation").hide();
    }
  });

  //window.onscroll = onRender;
  onRender();

  $(window).resize(function () {
    if ($(window).width() >= mobileWidth && $(window).height() > 780) {
      $(".wrapper-navigation").scrollLeft(0);
      $(".wrapper-navigation").show();
    }
    onRender();
  });

  window.addEventListener(
    "orientationchange",
    function () {
      // $('.mobile .wrapper-navigation, #nav-toggle').removeClass("active");
    },
    false
  );

  $(".navList1 .hasSub a, .backBtn").click(function () {
    if ($("body").hasClass("mobile")) {
      $(".wrapper-subnavigation").show();
      showSubMobile(this);
    } else {
      showSubDesktop(this);
    }
    return false;
  });

  $("form").parsley();

  $('form.schnuppern input[name="participation"], form.tandem input[name="participation"]').click(function () {
    if ($(this).val() == "möchte einen Gutschein bestellen." || $(this).val() == "Ich möchte einen Gutschein bestellen.") {
      console.log("gutschein");
      $(".only_anmelden").hide();
      $(".only_anmelden, .only_anmelden input").removeAttr("required");
    } else {
      console.log("anmelden");
      $(".only_anmelden").show();
      $(".only_anmelden, .only_anmelden input").attr("required", "true");
    }
  });
});

function showSubMobile(btn) {
  var scrollWidth = $(window).width() - 15;
  if ($(btn).hasClass("backBtn")) {
    scrollWidth *= -1;
  } else {
    $(".wrapper-subnavigation ul").hide();
    var toShow = "." + $(btn).attr("data-sub");
    $(toShow).css("height", "auto");
    $(toShow).show();
    if ($(toShow).length > 1) {
      var elm = $(toShow);
      $(elm).find(".backBtn").show();
      $(elm[1]).find(".backBtn").hide();
    }
  }

  $(".wrapper-navigation").animate({ scrollLeft: scrollWidth }, 200);
}

function showSubDesktop(btn) {
  $(".wrapper-subnavigation ul").hide();
  if ($(btn).hasClass("backBtn")) {
    $("html").removeClass("noscroll");
    $(".wrapper-subnavigation").hide();
  } else {
    var toShow = "." + $(btn).attr("data-sub");
    $(toShow).show();
    $(".wrapper-subnavigation").show();
    $(".navList2").css("left", -2 * $(toShow).width() - 15);
    $(".navList2").animate({ left: 0 }, 400);
    $("html").addClass("noscroll");

    if ($(toShow).length > 1) {
      var elm = $(toShow);
      $(elm).find(".backBtn").show();
      $(elm[0]).find(".backBtn").css("visibility", "hidden");
      var h = 0;
      $(toShow).each(function () {
        $(this).css("height", "auto");
        if ($(this).height() > h) h = $(this).height();
      });
      $(toShow).height(h);
    }
  }
}

function onRender() {
  console.log("onRender", $(window).width(), mobileWidth);
  // if ($(window).width() <= mobileWidth && $(window).height() < 780) {
  if ($(window).width() <= mobileWidth) {
    $("body").addClass("mobile");
    $("html").removeClass("noscroll");
  } else {
    $("body").removeClass("mobile");
    $(".wrapper-subnavigation").hide();
  }
}
